const endpoint = "/.netlify/functions/admin";

export async function adminRequest(accessToken, action, values = {}) {
  if (typeof accessToken !== "string" || !accessToken) throw new Error("Sign in again to use administration.");
  let response;
  try {
    response = await fetch(endpoint, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ action, ...values }),
    });
  } catch {
    throw Object.assign(new Error("The administration service could not be reached. If this was a change, refresh the account and check its status before retrying."), {
      code: "ADMIN_OUTCOME_UNKNOWN",
    });
  }
  let result;
  try {
    result = await response.json();
  } catch {
    throw Object.assign(new Error("The administration response could not be confirmed. If this was a change, refresh the account and check its status before retrying."), {
      code: "ADMIN_OUTCOME_UNKNOWN",
    });
  }
  if (!response.ok) {
    const error = new Error(typeof result?.error === "string"
      ? result.error
      : "The administration request could not be completed.");
    if (response.status >= 500 && [
      "set-enabled", "delete-user", "delete-own-account",
      "restore-begin", "restore-batch", "restore-commit", "restore-cancel",
    ].includes(action)) error.code = "ADMIN_OUTCOME_UNKNOWN";
    throw error;
  }
  if (!result || typeof result !== "object") throw new Error("The administration response was invalid.");
  return result;
}

export const ADMIN_BACKUP_FORMAT = "guitar-charts-user-backup";
